export default class PostalCodeMask {

  static checkPostalCodeMask(isoCode, postalCode) {
    if (!isoCode || !postalCode) {
      return false
    }

    const normalizedIsoCode = String(isoCode).trim().toUpperCase()
    const normalizedPostalCode = String(postalCode).trim()

    if (normalizedIsoCode === "ES") {
      return this.isValidSpanishPostalCode(normalizedPostalCode)
    }

    if (normalizedIsoCode === "PT") {
      return this.isValidPortuguesePostalCode(normalizedPostalCode)
    }

    return false
  }

  static isValidSpanishPostalCode(postalCode) {
    const spainPostalCodeRegex = /^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/
    return spainPostalCodeRegex.test(String(postalCode))
  }

  static isValidPortuguesePostalCode(postalCode) {
    const portugalPostalCodeRegex = /^[0-9]{4}(-[0-9]{3}| [0-9]{3})?$/
    return portugalPostalCodeRegex.test(String(postalCode))
  }
}



// WEBPACK FOOTER //
// ./src/components/Utilities/PostalCodeMask.js